import React from 'react';
import { LoginForm, ResetPasswordForm } from 'components/atomic/organisms/index';
import { useLocation } from 'react-router-dom';

const HomePage = () =>
	// { setApiError }
	{
		const location = useLocation();

		const showLogin = !location.search.includes('reset-password');

		return (
			<div>
				{showLogin ? (
					<LoginForm
					// setApiError={setApiError}
					/>
				) : (
					<ResetPasswordForm />
				)}
			</div>
		);
	};
export default HomePage;
